import React, { useEffect, useState } from "react";
import { TagIcon } from "@phosphor-icons/react";
import { customerApi } from "@/lib/customerApi";

export function useMyDiscount() {
  const [d, setD] = useState(null);
  useEffect(() => { customerApi.get("/store/account/discount").then((r) => setD(r.data.discount)).catch(() => {}); }, []);
  return d;
}

export const discounted = (price, d) => (d ? Math.round(price * (100 - d.percent)) / 100 : price);

export function DiscountBanner({ d }) {
  if (!d) return null;
  const until = d.expires_at ? new Date(d.expires_at * 1000).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }) : null;
  return (
    <div data-testid="plan-discount-banner" className="mt-4 flex items-start gap-3 rounded-xl border border-[#FBBF24]/60 bg-[#FBBF24]/10 p-4 text-sm text-[#FDE68A]">
      <TagIcon size={18} weight="fill" className="mt-0.5 flex-shrink-0 text-[#FBBF24]" />
      <div>
        <b>{d.percent}% off your first month</b> {d.source === "launch_list" ? "- thanks for joining the launch list." : d.note ? `- ${d.note}.` : ""}{" "}
        It's applied automatically at checkout. Later months are charged at the normal price.
        {until && <span className="block text-xs text-[#FBBF24] mt-1" data-testid="plan-discount-expiry">Use it by {until}.</span>}
      </div>
    </div>
  );
}
